export const awards = [
  {
    title: "서울시장 최우수상 수상",
    subtitle: "새싹(SeSSac) 해커톤",
    year: "2024",
    link: "https://www.yna.co.kr/view/AKR20240802119700004",
    image: "/portfolio/assets/awards/sessac.jpg",
  },
  {
    title: "우수상 수상",
    subtitle: "POSCO 주최 태양광 발전량 예측 경진대회",
    year: "2023",
    link: "https://www.sisanews24.co.kr/10164",
    image: "/portfolio/assets/awards/posco.jpg",
  },
  {
    title: "AI 바리스타 시연",
    subtitle: "서울 카페쇼",
    year: "2023",
    link: "https://www.yna.co.kr/view/PYH20231108109500013",
    image: "/portfolio/assets/awards/barista.jpg",
  },
];